export default __webpack_public_path__ + "static/media/pod1.ec628633.jpg";